import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/caplock.svg';
const CapLock = () => React.createElement(IconSvg, null);
export default CapLock;
